import moment from 'moment';

export function formatUtcDate(
	value: string | number | Date | undefined | null,
	pattern: string,
): string {
	if (value === undefined || value === null || value === '') {
		return '-';
	}

	const parsedDate = moment.utc(value).local();

	if (!parsedDate.isValid()) {
		return '-';
	}

	return parsedDate.format(pattern);
}